import React from "react";
import './project.css'
import webs5 from "./web5.JPG";
import tweetme from "./tweetme.JPG";
import beer1 from "./beer1.png";
import airbnb from "./airbnb-cl.png";
import netflix from "./netf-clone.png";
import ig from "./ig=clone.png";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import { Button, Card, CardActionArea, CardActions } from "@material-ui/core";
function Projects() {
	return (
		<div className="projects">
			<div className="myprojects">
				<h1>Projects</h1>
				<div className="projectScreenshots">
					<Card>
						<CardActionArea>
							<CardMedia
								component="img"
								height=""
								image={webs5}
							/>
							<CardContent>
								<p>
									An in-house web application built for
									tracking customers’ enquiries on real-estate
									property to either buy or sell utilizing
									Angular, TypeScript, HTML, SASS and
									Firebase.
								</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires">
									<a href="https://github.com/joshuandeleva">
										Checkout
									</a>
								</Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card>
						<CardActionArea>
							<CardMedia
								component="img"
								height=""
								image={tweetme}
							/>
							<CardContent>
								<p>
									An in-house web application built for
									tracking customers’ enquiries on real-estate
									property to either buy or sell utilizing
									Angular, TypeScript, HTML, SASS and
									Firebase.
								</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires">
									<a href="https://tweetme-40228.web.app">
										Checkout
									</a>
								</Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card>
						<CardActionArea>
							<CardMedia component="img" height="" image={ig} />
							<CardContent>
								<p>
									creating account with firebase , uploading
									anf retrieving the data
								</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires">
									<a href="https://instagram-clone-e7098.web.app">
										Checkout
									</a>
								</Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card className="cardProjects">
						<CardActionArea>
							<CardMedia
								component="img"
								height="250px"
								image={netflix}
							/>
							<CardContent>
								<p>
									A real time movies site which utilizes the
									tmdb .org api to get the movies and
									categorizes into according to genre and
									trends
								</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires">
									<a href="https://netflix-clone-7dfee.web.app">
										Checkout
									</a>
								</Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card className="cardProjects">
						<CardActionArea>
							<CardMedia
								component="img"
								height="250px"
								image={airbnb}
							/>
							<CardContent>
								<p>airbnb challenge</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires">
									<a href="https://airbnb-clone-71d27.web.app">
										Checkout
									</a>
								</Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card className="cardProjects">
						<CardActionArea>
							<CardMedia
								component="img"
								height="250px"
								image={beer1}
							/>
							<CardContent>
								<p>
									Aapplications generating random beers using
									the punky beer api ,shares out the different
									levels of alcohol and year of make.
								</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires">
									<a href="https://punkbeer-api.netlify.app">
										Checkout
									</a>
								</Button>
							</CardActions>
						</CardActionArea>
					</Card>
				</div>
            </div>
            <div className="view__all" style={{marginTop:"30px" , alignItems:"center" , justifyContent:"center"}}>
                <Button style={{marginTop:"30px !important" , backgroundColor:"#36cb00 !important"}}><a href="https://github.com/joshuandeleva">
										View all on Github
									</a></Button>
            </div>
		</div>
	);
}
export default Projects;
